<div class="page-main">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-6" [ngClass]="{'hidden': loaderStatus}">
        <div class="login-box">

          <div class="main-box">
            <h2 class="title title-balck" style="padding-bottom: 15px; padding-top: 35px">You're all set!</h2>
            <div><span style="font-weight: 600!important">Thanks!</span> Your email address has been verified</div>
            <div>
              You can now sign in with your  account
            </div>
            <button (click)="gotoSignIn()" mat-flat-button color="accent" type="button" class="full-width verify-btn">Sign In</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <p>login</p> -->

@if (loaderStatus) {
  <div class="loader-box">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
}
